import React, { useContext, useMemo, useState } from "react";
import { round } from "lodash";
import { Link } from "react-router-dom";
import { useEntity, useService } from "student-front-commons/src/hooks";
import CourseThemeContext from "../../core/CourseThemeContext";
import { PROFILE_SCHEMA } from "student-front-commons/src/schemas";
import Separator from "../../core/Separator";
import TranslatedText from "../../core/TranslatedText";
import Async from "../../core/Async";
import ProgressBar from "../../core/ProgressBar";
import FlexRow from "../../core/FlexRow";
import MessageChannelCounter from "../../core/message/MessageChannelCounter";
import { getHomeworksCount, getHomeworksStats } from "student-front-commons/src/services/homeworkService";
import { GREY_5, WHITE } from "../../consts/color";

export default function HomeworkStatsPanel() {
  const courseThemeContext = useContext(CourseThemeContext);

  const [data, setData] = useState();
  const [homeworksCount, setHomeworksCount] = useState(0);
  const profile = useEntity(PROFILE_SCHEMA, sessionStorage.getItem("id"));

  const [isFetching] = useService(getHomeworksStats, {
    autoStart: true,
    onData: setData,
  });

  useService(getHomeworksCount, {
    autoStart: true,
    onData: (data) => setHomeworksCount(data.count),
  });

  const progress = useMemo(() => {
    if (!data || !data.total) {
      return 0;
    }
    return round((data?.completed / data?.total) * 100, 0);
  }, [data]);

  if (
    !profile ||
    !profile.activeCourses.length ||
    !profile.activeCourses.find((course) => !course.distributor) ||
    !data?.total
  ) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: WHITE,
        borderRadius: 3,
        boxShadow: "0px 1px 3px 0 rgba(0, 0, 0, 0.2)",
        position: "relative",
        zIndex: 2,
        width: "max-content",
        height: 140,
      }}
    >
      <Async fetching={isFetching}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px 35px 20px 35px",
          }}
        >
          <FlexRow position="relative">
            <TranslatedText
              translateKey="homeworks.progressPanel.title"
              style={{
                margin: 0,
                fontSize: 14,
                color: courseThemeContext.primary,
                fontWeight: "medium",
              }}
            />
            {!!homeworksCount && (
              <div style={{ top: -8, right: -16, position: "absolute" }}>
                <MessageChannelCounter value={homeworksCount} />
              </div>
            )}
          </FlexRow>
          <Separator size="sm" />
          <ProgressBar percentage={progress} height="12px" />
          <Separator size="xxs" />
          <TranslatedText
            translateKey="homeworks.progressPanel.homeworksProgress"
            values={{ progress, total: data?.total, completed: data?.completed }}
            style={{
              margin: 0,
              fontSize: 11,
              color: "#424242",
            }}
          />
          <Separator size="md" />
          <Separator size="xs" />
          <Link
            aria-label="acessar seu curso"
            to={`course/${profile.activeCourses.find((course) => !course.distributor).id}/homeworks`}
            style={{
              margin: 0,
              fontSize: 13,
              color: GREY_5,
            }}
          >
            <TranslatedText translateKey="homeworks.progressPanel.accessHomeworks" />
          </Link>
        </div>
      </Async>
    </div>
  );
}
